import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";

export type VerifyResumeOtpVariables = {
  email: string;
  code: string;
};

function useVerifyResumeOtp(
  options?: MutationOptions<
    APIResponse<{ token: string }>,
    APIError,
    VerifyResumeOtpVariables
  >
) {
  const {
    isLoading: verifying,
    isError: isVerifyError,
    error: verifyError,
    mutate: verifyResumeOtp,
    reset,
  } = useMutation<
    APIResponse<{ token: string }>,
    APIError,
    VerifyResumeOtpVariables
  >(
    "verify_resume_profile_otp",
    async (variables) =>
      await post(
        API_URL +
          "/onboarding/users/onboarding/resume-profile/verify-email-otp",
        variables
      ),
    {
      ...options,
    }
  );

  return {
    verifyResumeOtp,
    verifying,
    isVerifyError,
    verifyError,
    resetVerify: reset,
  };
}

export default useVerifyResumeOtp;
